// Auth
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_RESPONSE = "LOGOUT_RESPONSE";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_RESPONSE = "AUTH_RESPONSE";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_CHECK = "AUTH_CHECK"
export const AUTH_ERROR_EMPTY = "AUTH_ERROR_EMPTY";
export const CREATE_CODE = "CREATE_CODE";
export const CHECK_CODE = "CHECK_CODE";
export const UPDATE_USER = "UPDATE_USER";
export const INCREMENT_TOKEN = "INCREMENT_TOKEN";
export const DECREMENT_TOKEN = "DECREMENT_TOKEN";
export const INCREMENT_TROPHY = "INCREMENT_TROPHY";
export const INCREMENT_MONEY = "INCREMENT_MONEY";
export const DECREMENT_MONEY = "DECREMENT_MONEY";
export const DECREMENT_MONEY_ERROR = "DECREMENT_MONEY_ERROR";

// Education
export const EDUCATION_REQUEST = "EDUCATION_REQUEST";
export const EDUCATION_RESPONSE = "EDUCATION_RESPONSE";
export const ADD_EDUCATION_RESPONSE = "ADD_EDUCATION_RESPONSE";
export const REMOVE_EDUCATION_RESPONSE = "REMOVE_EDUCATION_RESPONSE";
export const EDUCATION_ERROR = "EDUCATION_ERROR";
export const EDUCATION_ERROR_EMPTY = "EDUCATION_ERROR_EMPTY";
export const ADD_STEP = "ADD_STEP";
export const EMPTY_STEP = "EMPTY_STEP";
export const REMOVE_STEP = "REMOVE_STEP";
export const UPDATE_STEP = "UPDATE_STEP";

// Intractive Education
export const ADD_LEVEL = "ADD_LEVEL";
export const EMPTY_LEVEL = "EMPTY_LEVEL";
export const REMOVE_LEVEL = "REMOVE_LEVEL";
export const UPDATE_LEVEL = "UPDATE_LEVEL";
export const SELECT_ANSWER = "SELECT_ANSWER";
export const EMPTY_ANSWER = "EMPTY_ANSWER";

// Blog
export const BLOG_REQUEST = "BLOG_REQUEST";
export const BLOG_RESPONSE = "BLOG_RESPONSE";
export const ADD_BLOG_RESPONSE = "ADD_BLOG_RESPONSE";
export const REMOVE_BLOG_RESPONSE = "REMOVE_BLOG_RESPONSE";
export const BLOG_ERROR = "BLOG_ERROR";
export const BLOG_ERROR_EMPTY = "BLOG_ERROR_EMPTY";

// Exam Constant's
export const EXAM_REQUEST = "EXAM_REQUEST";
export const EXAM_RESPONSE = "EXAM_RESPONSE";
export const ADD_EXAM_RESPONSE = "ADD_EXAM_RESPONSE";
export const EDIT_EXAM_RESPONSE = "EDIT_EXAM_RESPONSE";
export const REMOVE_EXAM_RESPONSE = "REMOVE_EXAM_RESPONSE";
export const EXAM_ERROR = "EXAM_ERROR";
export const EXAM_ERROR_EMPTY = "EXAM_ERROR_EMPTY";

// Category Content's
export const CATEGORY_REQUEST = "CATEGORY_REQUEST";
export const CATEGORY_RESPONSE = "CATEGORY_RESPONSE";
export const ADD_CATEGORY_RESPONSE = "ADD_CATEGORY_RESPONSE";
export const REMOVE_CATEGORY_RESPONSE = "REMOVE_CATEGORY_RESPONSE";
export const CATEGORY_ERROR = "ERROR";
export const CATEGORY_ERROR_EMPTY = "ERROR_EMPTY";

// Style Constant's
export const OPEN_SIDENAV = "OPEN_SIDENAV";
export const CLOSE_SIDENAV = "CLOSE_SIDENAV";
export const CURRENT_TAB = "CURRENT_TAB";

//Search Course
export const SEARCH_IE_REQUEST = "SEARCH_IE_REQUEST";
export const SEARCH_IE_SUCCESS = "SEARCH_IE_SUCCESS";
export const SEARCH_IE_FAILURE = "SEARCH_IE_FAILURE";

//add user
export const ADD_USER_REQUEST = "ADD_USER_REQUEST"